import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "pa-4" };
const _hoisted_2 = { class: "require-field-wrapper pa-4" };
const _hoisted_3 = { class: "text-black body1-text" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_btn = _resolveComponent("v-btn");
    const _component_DialogHeader = _resolveComponent("DialogHeader");
    const _component_v_divider = _resolveComponent("v-divider");
    const _component_DialogFooter = _resolveComponent("DialogFooter");
    const _component_v_card = _resolveComponent("v-card");
    const _component_v_dialog = _resolveComponent("v-dialog");
    const _directive_ui_permission = _resolveDirective("ui-permission");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createCommentVNode(" 배차 취소 "),
        (_ctx.policy.isCancelAllocatedAvailable)
            ? (_openBlock(), _createBlock(_component_v_dialog, {
                key: 0,
                modelValue: _ctx.dialog,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.dialog) = $event)),
                "content-class": "responsive-dialog"
            }, {
                activator: _withCtx(({ props }) => [
                    _withDirectives((_openBlock(), _createElementBlock("div", null, [
                        _createVNode(_component_v_btn, _mergeProps(props, {
                            class: "mr-2 btn-outlined-basic",
                            variant: "outlined",
                            large: "",
                            width: "200",
                            height: "52"
                        }), {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.lc}cancel_allocated`)), 1 /* TEXT */)
                            ]),
                            _: 2 /* DYNAMIC */
                        }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */)
                    ])), [
                        [_directive_ui_permission, [
                                _ctx.userPermission.P_EXECUTE_ALLOCATE_WORKER,
                            ]]
                    ])
                ]),
                default: _withCtx(() => [
                    _createVNode(_component_v_card, null, {
                        default: _withCtx(() => [
                            _createVNode(_component_DialogHeader, {
                                title: _ctx.$t(`${_ctx.lc}cancel_allocated`),
                                "on-cancel": _ctx.handleClickCancel
                            }, null, 8 /* PROPS */, ["title", "on-cancel"]),
                            _createVNode(_component_v_card, {
                                flat: "",
                                tile: ""
                            }, {
                                default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_1, [
                                        _createElementVNode("div", _hoisted_2, [
                                            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t(`${_ctx.lc}cancel_allocated_dialog_content`)), 1 /* TEXT */)
                                        ])
                                    ]),
                                    _createVNode(_component_v_divider),
                                    _createVNode(_component_DialogFooter, {
                                        cancel: true,
                                        ok: true,
                                        "on-cancel": _ctx.handleClickCancel,
                                        "on-ok": _ctx.handleClickCancelAllocated
                                    }, null, 8 /* PROPS */, ["on-cancel", "on-ok"])
                                ]),
                                _: 1 /* STABLE */
                            })
                        ]),
                        _: 1 /* STABLE */
                    })
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["modelValue"]))
            : _createCommentVNode("v-if", true)
    ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */));
}
